export default __webpack_public_path__ + "static/media/exterior16.c87f5f76.webp";